/**
 * Aggregated Layer names are kept unchanged as they appear in IrriWatch 1.0
 */
export enum AggregatedLayerType {
    VEGETATION_COVER = "vegetation_cover",
    UNIFORMITY_VEGETATION_COVER_STDMEAN = "uniformity_vegetation_cover_stdmean",
    IRRIGATION_YESNO = "irrigation_yesno",
    AREA_PERCENTAGE_REQUIRING_IRRIGATION = "area_percentage_requiring_irrigation",
    AREA_PERCENTAGE_OVER_IRRIGATION = "area_percentage_over_irrigation",
    FULLNESS = "fullness",
    MIN_APPLIED_WATER = "min_applied_water",
    MAX_APPLIED_WATER = "max_applied_water",
    ADVICED_APPLIED_WATER = "adviced_applied_water",
    TIME_UNTIL_NEXT_IRRIGATION = "time_until_next_irrigation",
    SOIL_MOISTURE_ROOT_ZONE_TODAY = "soil_moisture_root_zone_today",
    SOIL_MOISTURE_ROOT_ZONE_TOMORROW_EVENING = "soil_moisture_root_zone_tomorrow_evening",
    CRITICAL_SOIL_MOISTURE_ROOT_ZONE_TOMORROW_EVENING = "critical_soil_moisture_root_zone_tomorrow_evening",
    SOIL_MOISTURE_TOP_SOIL = "soil_moisture_top_soil",
    SOIL_WATER_POTENTIAL_ROOT_ZONE = "soil_water_potential_root_zone",
    ACTUAL_EVAPOTRANSPIRATION = "actual_evapotranspiration",
    ACTUAL_EVAPOTRANSPIRATION_MW = "actual_evapotranspiration_mw",
    POTENTIAL_EVAPOTRANSPIRATION = "potential_evapotranspiration",
    POTENTIAL_TRANSPIRATION = "potential_transpiration",
    PENMANN_MONTEITH_REFERENCE_ET0 = "penmann_monteith_reference_et0",
    PENMANN_MONTEITH_CROP_COEFFICIENT_KC_MW = "penmann_monteith_crop_coefficient_kc_mw",
    ACTUAL_CROP_PRODUCTION = "actual_crop_production",
    WATER_UNLIMITED_CROP_PRODUCTION = "water_unlimited_crop_production",
    TRANSPIRATION_DEFICIT = "transpiration_deficit",
    RELIABILITY_MOISTURE_MW = "reliability_moisture_mw",
    UNIFORMITY_SOIL_MOISTURE_STDMEAN_MW = "uniformity_soil_moisture_stdmean_mw",
    UNIFORMITY_SOIL_MOISTURE_STDMEAN_MW_CLASSES = "uniformity_soil_moisture_stdmean_mw_classes",
    WATER_PRODUCTIVITY_MW = "water_productivity_mw",
    FIELD_EFFICIENCY_MW = "field_efficiency_mw",
    APPLIED_WATER_MW = "applied_water_mw",
    RELIABILITY_MOISTURE = "reliability_moisture",
    PRECIPITATION_MW = "precipitation_mw",
    UNIFORMITY_SOIL_MOISTURE_STDMEAN = "uniformity_soil_moisture_stdmean",
    WATER_PRODUCTIVITY = "water_productivity",
    FIELD_EFFICIENCY = "field_efficiency",
    APPLIED_WATER = "applied_water",
    APPLIED_WATER_CORR = "applied_water_corr",
    IRRIGATION_AMOUNT_CUMULATIVE = "irrigation_amount_cumulative",
    TOMORROW_SOIL_WATER_POTENTIAL_WITHOUT_IRRIGATION = "tomorrow_soil_water_potential_without_irrigation",
    TOMORROW_PENMANN_MONTEITH_REFERENCE_ET0 = "tomorrow_penmann_monteith_reference_et0",
    TOMORROW_ACTUAL_EVAPOTRANSPIRATION = "tomorrow_actual_evapotranspiration",
    ACTUAL_EVAPORATION = "actual_evaporation",
    ACTUAL_TRANSPIRATION = "actual_transpiration",
    ACTUAL_TRANSPIRATION_CUMULATIVE = "actual_transpiration_cumulative",
    TRANSPIRATION_RATIO = "transpiration_ratio",
    R_CANOPY_INST = "r_canopy_inst",
    R_CANOPY_INST_MIN = "r_canopy_inst_min",
    EFFECTIVE_LAI = "effective_lai",
    STOMATAL_RESISTANCE = "stomatal_resistance",
    STOMATAL_CONDUCTANCE = "stomatal_conductance",
    MOISTURE_STRESS = "moisture_stress",
    MOISTURE_STRESS_BIOMASS = "moisture_stress_biomass",
    THERMAL_STRESS_BIOMASS_24 = "thermal_stress_biomass_24",
    THERMAL_STRESS_BIOMASS = "thermal_stress_biomass",
    VPD_STRESS_BIOMASS_24 = "vpd_stress_biomass_24",
    VPD_STRESS_BIOMASS = "vpd_stress_biomass",
    CROP_TOTAL_STRESS = "crop_total_stress",
    CROP_TOTAL_STRESS_PRODUCTION_LOSS = "crop_total_stress_production_loss",
    KC_MAX_ETPOT = "kc_max_etpot",
    LAND_SURFACE_TEMPERATURE = "land_surface_temperature",
    LAND_SURFACE_TEMPERATURE_CELCIUS = "land_surface_temperature_celcius",
    COLD_VEGETATION_PIXEL_TEMPERATURE = "cold_vegetation_pixel_temperature",
    COLD_WATER_PIXEL_TEMPERATURE = "cold_water_pixel_temperature",
    HOT_PIXEL_TEMPERATURE = "hot_pixel_temperature",
    TS_DEM = "ts_dem",
    AIR_TEMPERATURE_INST = "air_temperature_inst",
    AIR_TEMPERATURE_24 = "air_temperature_24",
    AIR_TEMPERATURE_MIN_24 = "air_temperature_min_24",
    AIR_TEMPERATURE_MAX_24 = "air_temperature_max_24",
    RELATIVE_HUMIDITY = "relative_humidity",
    RELATIVE_HUMIDITY_24 = "relative_humidity_24",
    INSTANTENIOUS_VPD = "instantenious_vpd",
    VPD_24 = "vpd_24",
    NDVI = "ndvi",
    NDII = "ndii",
    SURFACE_ALBEDO = "surface_albedo",
    LAI = "lai",
    ROOT_DEPTH = "root_depth",
    TOTAL_ROOT_DEPTH = "total_root_depth",
    OBSTACLE_HEIGHT = "obstacle_height",
    PENMANN_MONTEITH_CROP_COEFFICIENT_KC = "penmann_monteith_crop_coefficient_kc",
    DEBRUIN_CROP_COEFFICIENT_KC = "debruin_crop_coefficient_kc",
    R_SOIL = "r_soil",
    DAILY_SOLAR_TRANSMISSIVITY = "daily_solar_transmissivity",
    DAILY_SOLAR_RADIATION = "daily_solar_radiation",
    SOLAR_RADIATION_CUMULATIVE = "solar_radiation_cumulative",
    DAILY_NET_RADIATION = "daily_net_radiation",
    RN_INST = "rn_inst",
    G_INST = "g_inst",
    H_INST = "h_inst",
    LE_INST = "le_inst",
    LE_INST_RAIN = "le_inst_rain",
    EF_INST = "ef_inst",
    EF_MAX = "ef_max",
    EF_FIRST = "ef_first",
    H_TACT_INST = "h_tact_inst",
    H_EACT_INST = "h_eact_inst",
    DEBRUIN_REFERENCE_ET0 = "debruin_reference_et0",
    BIOMASS_PRODUCTION_STRESS_MOISTURE = "biomass_production_stress_moisture",
    PRECIPITATION = "precipitation",
    RUNOFF_Q = "runoff_q",
    RUNOFF_Q_CUMULATIVE = "runoff_q_cumulative",
    RUNOFF_R = "runoff_r",
    RUNOFF_R_CUMULATIVE = "runoff_r_cumulative",
    PERCOLATION = "percolation",
    PERCOLATION_CUMULATIVE = "percolation_cumulative",
    THETA_SAT_SUB = "theta_sat_sub",
    THETA_FC_SUB = "theta_fc_sub",
    THETA_RES_SUB = "theta_res_sub",
    THETA_WP_SUB = "theta_wp_sub",
    WATER_STORAGE_ROOT_ZONE = "water_storage_root_zone",
    SOIL_MOISTURE_HOLDING_CAPACITY = "soil_moisture_holding_capacity",
    CRITICAL_SOIL_MOISTURE_ROOT_ZONE = "critical_soil_moisture_root_zone",
    SOIL_MOISTURE_STANDARD_DEVIATION = "soil_moisture_standard_deviation",
    UNIFORMITY_CROP_PRODUCTION_CUMULATIVE_STDMEAN = "uniformity_crop_production_cumulative_stdmean",
    SOIL_MOISTURE_PERCENTILE5 = "soil_moisture_percentile5",
    SOIL_MOISTURE_PERCENTILE95 = "soil_moisture_percentile95",
    VEGETATION_COVER_PERCENTILE5 = "vegetation_cover_percentile5",
    VEGETATION_COVER_PERCENTILE95 = "vegetation_cover_percentile95",
    CROP_PRODUCTION_CUMULATIVE_PERCENTILE5 = "crop_production_cumulative_percentile5",
    CROP_PRODUCTION_CUMULATIVE_PERCENTILE95 = "crop_production_cumulative_percentile95",
    ACTUAL_SOIL_MOISTURE_PRECIPITATION = "actual_soil_moisture_precipitation",
    WATER_STORAGE_PRECIPITATION = "water_storage_precipitation",
    CROP_PRODUCTION_STANDARD_DEVIATION = "crop_production_standard_deviation",
    CROP_PRODUCTION_PERCENTILE5 = "crop_production_percentile5",
    CROP_PRODUCTION_PERCENTILE95 = "crop_production_percentile95",
    CROP_PRODUCTION_CUMULATIVE = "crop_production_cumulative",
    CROP_PRODUCTION_UPDATE = "crop_production_update",
    CROP_PRODUCTION_BELOW = "crop_production_below",
    CROP_PRODUCTION_ABOVE = "crop_production_above",
    CROP_PRODUCTION_BELOW_CUMULATIVE = "crop_production_below_cumulative",
    CROP_PRODUCTION_ABOVE_CUMULATIVE = "crop_production_above_cumulative",
    REL_INCREASE_DMP_ABOVE = "rel_increase_dmp_above",
    ACTUAL_EVAPOTRANSPIRATION_APPLIED_WATER = "actual_evapotranspiration_applied_water",
    ACTUAL_EVAPOTRANSPIRATION_APPLIED_WATER_CUMULATIVE = "actual_evapotranspiration_applied_water_cumulative",
    PERCOLATION_APPLIED_WATER = "percolation_applied_water",
    ACTUAL_EVAPOTRANSPIRATION_CUMULATIVE = "actual_evapotranspiration_cumulative",
    PRECIPITATION_CUMULATIVE = "precipitation_cumulative",
    WATER_PRODUCTIVITY_SEASON = "water_productivity_season",
    SOIL_WATER_POTENTIAL_PERCENTILE5 = "soil_water_potential_percentile5",
    SOIL_WATER_POTENTIAL_PERCENTILE95 = "soil_water_potential_percentile95",
    SOIL_WATER_POTENTIAL_CRITICAL = "soil_water_potential_critical",
    SOIL_WATER_POTENTIAL_FC = "soil_water_potential_fc",
    LEAF_WATER_POTENTIAL = "leaf_water_potential",
    NDRE = "ndre",
    VSDI = "vsdi",
    LUE = "lue",
    SPAD = "spad",
    N_LEAF_PERCENTAGE = "n_leaf_percentage",
    N_LEAF_PRODUCTION = "n_leaf_production",
    MOISTURE_CONTENT_CANE = "moisture_content_cane",
    SUGAR_CONTENT_CANE = "sugar_content_cane",
    ATTAINABLE_BIOMASS_PRODUCTION = "attainable_biomass_production",
    ATTAINABLE_BIOMASS_PRODUCTION_CUMULATIVE = "attainable_biomass_production_cumulative",
    RELATIVE_BIOMASS_PRODUCTION = "relative_biomass_production",
    RELATIVE_BIOMASS_PRODUCTION_MWSEASON = "relative_biomass_production_mwseason",
    RELATIVE_BIOMASS_PRODUCTION_MW3 = "relative_biomass_production_mw3",
    BIOMASS_PRODUCTION_ALERT_LEVEL = "biomass_production_alert_level",
    WATER_UNLIMITED_CROP_PRODUCTION_CUMULATIVE = "water_unlimited_crop_production_cumulative",
    PRODUCTION_GAP = "production_gap",
    PRODUCTION_GAP_CUMULATIVE = "production_gap_cumulative",
    KSOLAR_NDVICORR_CUMULATIVE = "ksolar_ndvicorr_cumulative",
    R_CANOPY_INST_NDVICORR_CUMULATIVE = "r_canopy_inst_ndvicorr_cumulative",
    CROP_PRODUCTION_NDVICORR_CUMULATIVE = "crop_production_ndvicorr_cumulative",
    NO_NDVI_DAYS = "no_ndvi_days",
    NO_NDVI_DAYS_UPDATE = "no_ndvi_days_update",
    KSAT_SUBSOIL = "ksat_subsoil",
    SAND_FRACTION = "sand_fraction",
    CLAY_FRACTION = "clay_fraction",
    ORGANIC_MATTER = "organic_matter",
    SOIL_TEMPERATURE = "soil_temperature",
    SOIL_TEMPERATURE_10CM = "soil_temperature_10cm",
    SOIL_TEMPERATURE_INST = "soil_temperature_inst",
    LEAF_TEMPERATURE_INST = "leaf_temperature_inst",
    CARBON_SUPPLY_IN_SOIL = "carbon_supply_in_soil",
    CARBON_DECOMPOSITION_IN_SOIL = "carbon_decomposition_in_soil",
    NET_CARBON_SUPPLY_IN_SOIL = "net_carbon_supply_in_soil",
    NET_CARBON_SUPPLY_IN_SOIL_CUMULATIVE = "net_carbon_supply_in_soil_cumulative",
    DELTA_ORGANIC_MATTER_CONTENT = "delta_organic_matter_content",
    METHANE_EMISSION_RICE = "methane_emission_rice",
    METHANE_EMISSION_RICE_CUMULATIVE = "methane_emission_rice_cumulative",
    SOIL_MOISTURE_ROOT_ZONE_SUB_PIXEL_TODAY = "soil_moisture_root_zone_sub_pixel_today",
    SOIL_WATER_POTENTIAL_ROOT_ZONE_SUB_PIXEL = "soil_water_potential_root_zone_sub_pixel",
    SOIL_MOISTURE_ROOT_ZONE_COMBINED_TODAY = "soil_moisture_root_zone_combined_today",
    SOIL_WATER_POTENTIAL_ROOT_ZONE_COMBINED = "soil_water_potential_root_zone_combined",
    AIR_COOLING = "air_cooling",
    RN_G_RATIO = "rn_g_ratio",
    SLOB_COEF = "slob_coef",
    APPLIED_WATER_ESTIMATED = "applied_water_estimated",
    THERMAL_DEGREES_DAYS_CUMULATIVE = "thermal_degrees_days_cumulative",
    REST_TERM = "rest_term",
    QUALITY_PER = "quality_per",
    SEASON_COUNT = "season_count",
    VEGT_COVER_RATIO = "vegt_cover_ratio",
    MOISTURE_RATIO = "moisture_ratio",
    E_CORRECTION_FACTOR = "e_correction_factor",
    FROST_DAY = "frost_day",
    HEAT_WAVE_DAY = "heat_wave_day",
    HEAVY_RAINFALL_DAY = "heavy_rainfall_day",
    NO_ASSUMED_IRRIGATION_DAYS = "no_assumed_irrigation_days",
    THERMAL_UPDATE = "thermal_update",
    VISIBLE_UPDATE = "visible_update",
    S2_DAY = "s2_day",
    LS_DAY = "ls_day",
    S3_DAY = "s3_day",
    VIIRS_DAY = "viirs_day",
    MODIS_DAY = "modis_day",
    ECO_DAY = "eco_day",
    FORECAST_ET0_8DAYS_SUM = "forecast_et0_8days_sum",
    MOISTURE_STATUS = "moisture_status",
    P_FCDP0 = "p_fcdp0",
    P_FCDP1 = "p_fcdp1",
    P_FCDP2 = "p_fcdp2",
    P_FCDP3 = "p_fcdp3",
    P_FCDP4 = "p_fcdp4",
    P_FCDP5 = "p_fcdp5",
    P_FCDP6 = "p_fcdp6",
    P_FCDP7 = "p_fcdp7",
    ET_FCDP0 = "et_fcdp0",
    ET_FCDP1 = "et_fcdp1",
    ET_FCDP2 = "et_fcdp2",
    ET_FCDP3 = "et_fcdp3",
    ET_FCDP4 = "et_fcdp4",
    ET_FCDP5 = "et_fcdp5",
    ET_FCDP6 = "et_fcdp6",
    ET_FCDP7 = "et_fcdp7",
    AW_FCDP0 = "aw_fcdp0",
    AW_FCDP1 = "aw_fcdp1",
    AW_FCDP2 = "aw_fcdp2",
    AW_FCDP3 = "aw_fcdp3",
    AW_FCDP4 = "aw_fcdp4",
    AW_FCDP5 = "aw_fcdp5",
    AW_FCDP6 = "aw_fcdp6",
    AW_FCDP7 = "aw_fcdp7",
    CRITICAL_SOIL_MOISTURE_ROOT_ZONE_FCDP0 = "critical_soil_moisture_root_zone_fcdp0",
    CRITICAL_SOIL_MOISTURE_ROOT_ZONE_FCDP1 = "critical_soil_moisture_root_zone_fcdp1",
    CRITICAL_SOIL_MOISTURE_ROOT_ZONE_FCDP2 = "critical_soil_moisture_root_zone_fcdp2",
    CRITICAL_SOIL_MOISTURE_ROOT_ZONE_FCDP3 = "critical_soil_moisture_root_zone_fcdp3",
    CRITICAL_SOIL_MOISTURE_ROOT_ZONE_FCDP4 = "critical_soil_moisture_root_zone_fcdp4",
    CRITICAL_SOIL_MOISTURE_ROOT_ZONE_FCDP5 = "critical_soil_moisture_root_zone_fcdp5",
    CRITICAL_SOIL_MOISTURE_ROOT_ZONE_FCDP6 = "critical_soil_moisture_root_zone_fcdp6",
    CRITICAL_SOIL_MOISTURE_ROOT_ZONE_FCDP7 = "critical_soil_moisture_root_zone_fcdp7",
    SOIL_MOISTURE_ROOT_ZONE_NO_IRRI_FCDP0 = "soil_moisture_root_zone_no_irri_fcdp0",
    SOIL_MOISTURE_ROOT_ZONE_NO_IRRI_FCDP1 = "soil_moisture_root_zone_no_irri_fcdp1",
    SOIL_MOISTURE_ROOT_ZONE_NO_IRRI_FCDP2 = "soil_moisture_root_zone_no_irri_fcdp2",
    SOIL_MOISTURE_ROOT_ZONE_NO_IRRI_FCDP3 = "soil_moisture_root_zone_no_irri_fcdp3",
    SOIL_MOISTURE_ROOT_ZONE_NO_IRRI_FCDP4 = "soil_moisture_root_zone_no_irri_fcdp4",
    SOIL_MOISTURE_ROOT_ZONE_NO_IRRI_FCDP5 = "soil_moisture_root_zone_no_irri_fcdp5",
    SOIL_MOISTURE_ROOT_ZONE_NO_IRRI_FCDP6 = "soil_moisture_root_zone_no_irri_fcdp6",
    SOIL_MOISTURE_ROOT_ZONE_NO_IRRI_FCDP7 = "soil_moisture_root_zone_no_irri_fcdp7",
    SOIL_MOISTURE_ROOT_ZONE_IRRI_FCDP0 = "soil_moisture_root_zone_irri_fcdp0",
    SOIL_MOISTURE_ROOT_ZONE_IRRI_FCDP1 = "soil_moisture_root_zone_irri_fcdp1",
    SOIL_MOISTURE_ROOT_ZONE_IRRI_FCDP2 = "soil_moisture_root_zone_irri_fcdp2",
    SOIL_MOISTURE_ROOT_ZONE_IRRI_FCDP3 = "soil_moisture_root_zone_irri_fcdp3",
    SOIL_MOISTURE_ROOT_ZONE_IRRI_FCDP4 = "soil_moisture_root_zone_irri_fcdp4",
    SOIL_MOISTURE_ROOT_ZONE_IRRI_FCDP5 = "soil_moisture_root_zone_irri_fcdp5",
    SOIL_MOISTURE_ROOT_ZONE_IRRI_FCDP6 = "soil_moisture_root_zone_irri_fcdp6",
    SOIL_MOISTURE_ROOT_ZONE_IRRI_FCDP7 = "soil_moisture_root_zone_irri_fcdp7",
    DRY_MATTER_PRODUCTION_GAP_FCDP0 = "dry_matter_production_gap_fcdp0",
    DRY_MATTER_PRODUCTION_GAP_FCDP1 = "dry_matter_production_gap_fcdp1",
    DRY_MATTER_PRODUCTION_GAP_FCDP2 = "dry_matter_production_gap_fcdp2",
    DRY_MATTER_PRODUCTION_GAP_FCDP3 = "dry_matter_production_gap_fcdp3",
    DRY_MATTER_PRODUCTION_GAP_FCDP4 = "dry_matter_production_gap_fcdp4",
    DRY_MATTER_PRODUCTION_GAP_FCDP5 = "dry_matter_production_gap_fcdp5",
    DRY_MATTER_PRODUCTION_GAP_FCDP6 = "dry_matter_production_gap_fcdp6",
    DRY_MATTER_PRODUCTION_GAP_FCDP7 = "dry_matter_production_gap_fcdp7",
    MIN_IRRIGATION_ROTATION = "min_irrigation_rotation",
    VERSION_NUMBER = "version_number",
    N_VAN_GENUCHTEN = "n_van_genuchten",
    FULL_PIXEL_SOIL_MOISTURE = "full_pixel_soil_moisture",
    LE_TPOT_INST = "le_tpot_inst",
    LE_EACT_INST = "le_eact_inst",
    RAH = "rah",
    ACTUAL_EVAPOTRANSPIRATION_PRECIPITATION = "actual_evapotranspiration_precipitation",
    AREA = "area",
    ACTUAL_EVAPOTRANSPIRATION_APPLIED_WATER_CUMULATIVE_RAW = "actual_evapotranspiration_applied_water_cumulative_raw",
    ACTUAL_EVAPOTRANSPIRATION_APPLIED_WATER_RAW = "actual_evapotranspiration_applied_water_raw",
    ACTUAL_EVAPOTRANSPIRATION_PRECIPITATION_CUMULATIVE = "actual_evapotranspiration_precipitation_cumulative",
    AIR_TEMPERATURE_24_T1 = "air_temperature_24_T1",
    RELATIVE_HUMIDITY_24_T1 = "relative_humidity_24_T1",
    WIND_SPEED_24_T1 = "wind_speed_24_T1",
    WIND_SPEED_24 = "wind_speed_24",
}
